<template>
    <!-- <div class="card p-4 m-2 pe-auto d-flex flex-row gap-2 align-items-center" @click="openModal"> -->
    <!-- <span><img :src="icon" style="width:40px; height: auto;" /></span> <span> {{ text }} </span> -->

    <!-- <TitleCard :title=text detail="<span class='text-success text-sm font-weight-bolder'></span> Some Text Here" :icon="{
        name: 'weekend',
        color: 'text-white',
        background: 'dark',
    }" @click="openModal" /> -->

    <!-- </div> -->
    <div class="card mb-2 cursor-pointer" :class="{ 'tab-card-highlight': highlight }" @click="openModal">
        <div class="card-header p-3 pt-2">
            <div class="icon icon-lg icon-shape shadow text-center border-radius-xl mt-n4 position-absolute"
                :class="`bg-gradient-${iconConfig.background} shadow-${iconConfig.background}`">
                <i class="material-icons opacity-10" :class="iconConfig.color" aria-hidden="true">{{ iconConfig.name }}</i>
            </div>
            <div class="pt-1 text-end">
                <p class="mb-0 text-sm text-capitalize font-weight-bold">{{ text }}       
                    <i class="material-icons text-sm">arrow_forward_ios</i>
                 </p>
                <h4 class="mb-0" v-if="value != null">{{ value }}</h4>
            </div>
        </div>
        <hr class="dark horizontal my-0" />
        <div class="card-footer p-3 text-end">
            <p class="mb-0 text-xs" v-if="detail != null">{{ detail }}</p>
        </div>
    </div>
</template>

<script>
import Modal from '@/components/Modal/Modal.vue';
import TitleCard from "./TitleCard.vue";

export default {
    data() {
        return {
            isModalOpened: false
        }
    },
    props: [
        'text',
        'icon',
        'detail',
        'showValue',
        'value',
        'highlight'
    ],
    computed: {
        iconConfig() {
            // Use provided icon prop or default
            if (this.icon && typeof this.icon === 'object') {
                return {
                    name: this.icon.name || 'weekend',
                    color: this.icon.color || 'text-white',
                    background: this.icon.background || 'dark'
                };
            }
            // Default icon
            return {
                name: 'weekend',
                color: 'text-white',
                background: 'dark'
            };
        }
    },
    component: {
        Modal,
        TitleCard
    },
    methods: {
        openModal: function () {
            this.isModalOpened = true;
        },
        closeModal: function () {
            this.isModalOpened = false;
        }
    }
}

</script>


<style>
.pe-auto {
    cursor: pointer;
}

.tab-card-highlight {
    animation: tab-card-pulse 1.5s ease-in-out infinite;
    border: 2px solid rgba(76, 175, 80, 0.6);
}

@keyframes tab-card-pulse {
    0%, 100% {
        box-shadow: 0 0 5px rgba(76, 175, 80, 0.3);
        transform: scale(1);
    }
    50% {
        box-shadow: 0 0 20px rgba(76, 175, 80, 0.7), 0 0 40px rgba(76, 175, 80, 0.3);
        transform: scale(1.02);
    }
}
</style>
